var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"foot_list"},_vm._l((_vm.datas),function(item,index){return _c('div',{key:index,staticClass:"foot_class"},[_c('div',{staticClass:"class_name"},[_vm._v(_vm._s(item.className))]),_vm._l((item.list),function(subItem,subIndex){return _c('div',{key:subIndex,staticClass:"item"},[_vm._v(" "+_vm._s(subItem.title)+" ")])})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }